import React, { useState } from 'react';

import { UiButton } from '../../ui/ui-button';

import { ManuallyAddApplicantDialog } from './mannually-add-applicant-dialog';

import { HeaderButtonAddIcon } from '../../util/material-design-icons';

type InputProps = {
  jobId: number;
  orgId: number;
  disabled?: boolean;
  variant?: 'primary' | 'secondary' | 'tertiary';
  onAddApplicant?: () => void;
  viewOnCreate?: boolean;
};

export const ManuallyAddApplicantButton = (props: InputProps) => {
  const { orgId, jobId, viewOnCreate, variant, disabled, onAddApplicant } = props;

  const [manuallyAddingApplicant, setManuallyAddingApplicant] = useState<boolean>(false);

  const manuallyAddApplicant = (addingApplicant: boolean) => () => {
    setManuallyAddingApplicant(addingApplicant);
  };

  return (
    <>
      <UiButton
        onClick={manuallyAddApplicant(true)}
        variant={variant || 'tertiary'}
        size="sm"
        disabled={disabled}
        startIcon={<HeaderButtonAddIcon />}
      >
        Add Applicant
      </UiButton>
      <ManuallyAddApplicantDialog
        jobId={jobId}
        orgId={orgId}
        onAddApplicant={onAddApplicant}
        viewOnCreate={viewOnCreate}
        manuallyAddingApplicant={manuallyAddingApplicant}
        setManuallyAddingApplicant={manuallyAddApplicant}
      />
    </>
  );
};
